var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDirection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.13107 1.57899L0.0834621 3.53784C-0.0278207 3.62209 -0.0278207 3.79059 0.0834621 3.87484L0.239258 4.04334C0.350541 4.1276 0.506337 4.1276 0.61762 4.04334L1.97527 2.75851L1.97527 12.0472C1.97527 12.1736 2.08655 12.3 2.24235 12.3H2.4204C2.55394 12.3 2.68748 12.1736 2.68748 12.0472L2.68748 2.75851L4.02288 4.04334C4.13416 4.1276 4.28995 4.1276 4.40124 4.04334L4.55703 3.87484C4.66832 3.79059 4.66832 3.62209 4.55703 3.53784L2.50943 1.57899C2.39815 1.47367 2.24235 1.47367 2.13107 1.57899Z",
    fill: "#FE273B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86893 12.421L11.9165 10.4622C12.0278 10.3779 12.0278 10.2094 11.9165 10.1252L11.7607 9.95666C11.6495 9.8724 11.4937 9.8724 11.3824 9.95666L10.0247 11.2415L10.0247 1.95275C10.0247 1.82638 9.91345 1.7 9.75765 1.7L9.5796 1.7C9.44606 1.7 9.31252 1.82638 9.31252 1.95275L9.31252 11.2415L7.97712 9.95665C7.86584 9.8724 7.71005 9.8724 7.59876 9.95665L7.44297 10.1252C7.33168 10.2094 7.33168 10.3779 7.44297 10.4622L9.49057 12.421C9.60185 12.5263 9.75765 12.5263 9.86893 12.421Z",
    fill: "#FE273B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirection);
export default __webpack_public_path__ + "static/media/direction.9056089051ff840dad1e1bef498a4a78.svg";
export { ForwardRef as ReactComponent };